import { TabWrap } from 'sections/TabWrap';

import { useTechnicalFeatures } from './TechnicalFeatures.hooks';

export function TechnicalFeatures(): React.ReactElement {
  const { sections } = useTechnicalFeatures();

  return <TabWrap sections={sections} />;
}
